import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ForkOutlinedSvg from "@ant-design/icons-svg/es/asn/ForkOutlined";
import AntdIcon from "../components/AntdIcon";
var ForkOutlined = function ForkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ForkOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ForkOutlined.displayName = 'ForkOutlined';
}
export default /*#__PURE__*/React.forwardRef(ForkOutlined);